/**
 * Branding Configuration
 * Central configuration for tenant-specific branding colors and assets
 */

// Tenant brand colors
export const BRAND_COLORS = {
  // HaliTrade - Chinese Red theme (main platform brand)
  HALITRADE: {
    primary: '#DC2626',    // Chinese Red
    secondary: '#B91C1C',  // Darker Red
    accent: '#EF4444'      // Light Red
  },

  // HaliFlow - Red theme (legacy, now redirects to HaliTrade)
  HALIFLOW: {
    primary: '#DC2626',
    secondary: '#B91C1C',
    accent: '#EF4444'
  },

  // HaliAgent - Soft Amber/Gold theme (less aggressive)
  HALIAGENT: {
    primary: '#D4A03A',    // Soft Gold/Amber
    secondary: '#C4922A',  // Darker Amber
    accent: '#E8B84A'      // Light Amber
  },

  // HaliLab - Purple theme
  HALILAB: {
    primary: '#8B5CF6',
    secondary: '#7C3AED',
    accent: '#A78BFA'
  },

  // Platform - Blue theme
  PLATFORM: {
    primary: '#3B82F6',
    secondary: '#2563EB',
    accent: '#60A5FA'
  },

  // Referral - Green theme
  REFERRAL: {
    primary: '#10B981',
    secondary: '#059669',
    accent: '#34D399'
  },

  // Investor - Teal theme
  INVESTOR: {
    primary: '#14B8A6',
    secondary: '#0D9488',
    accent: '#2DD4BF'
  },

  // HaliFund - Green theme
  HALIFUND: {
    primary: '#10B981',
    secondary: '#059669',
    accent: '#34D399'
  }
};

// Tenant logos
export const BRAND_LOGOS = {
  HALITRADE: '/assets/halitrade-logo-red.svg',
  HALIFLOW: '/assets/halitrade-logo-red.svg',
  HALIAGENT: '/assets/halitrade-logo-yellow.svg',
  HALILAB: '/assets/halilab-logo.svg',
  PLATFORM: '/assets/halitrade-logo-red.svg',
  REFERRAL: '/assets/halitrade-logo-red.svg',
  INVESTOR: '/assets/halitrade-logo-red.svg',
  HALIFUND: '/assets/halifund-logo.svg'
};

// Tenant brand names and subtitles
export const BRAND_INFO = {
  HALITRADE: {
    name: 'HaliTrade',
    displayName: { prefix: 'Hali', highlight: 'Trade' },
    subtitle: 'Trade Finance Platform',
    sidebarSubtitle: 'powered by HaliSoft'
  },
  HALIFLOW: {
    name: 'HaliTrade',
    displayName: { prefix: 'Hali', highlight: 'Trade' },
    subtitle: 'Trade Finance Platform',
    sidebarSubtitle: 'powered by HaliSoft'
  },
  HALIAGENT: {
    name: 'HaliAgent',
    displayName: { prefix: 'Hali', highlight: 'Agent' },
    subtitle: 'Agent Portal',
    sidebarSubtitle: 'powered by HaliSoft'
  },
  HALILAB: {
    name: 'HaliLab',
    displayName: { prefix: 'Hali', highlight: 'Lab' },
    subtitle: 'Innovation Hub',
    sidebarSubtitle: 'powered by HaliSoft'
  },
  PLATFORM: {
    name: 'HaliTrade',
    displayName: { prefix: 'Hali', highlight: 'Trade' },
    subtitle: 'Platform Admin',
    sidebarSubtitle: 'powered by HaliSoft'
  },
  REFERRAL: {
    name: 'HaliTrade',
    displayName: { prefix: 'Hali', highlight: 'Trade' },
    subtitle: 'Referral Partner',
    sidebarSubtitle: 'powered by HaliSoft'
  },
  INVESTOR: {
    name: 'HaliTrade',
    displayName: { prefix: 'Hali', highlight: 'Trade' },
    subtitle: 'Investor Portal',
    sidebarSubtitle: 'powered by HaliSoft'
  },
  HALIFUND: {
    name: 'HaliFund',
    displayName: { prefix: 'Hali', highlight: 'Fund' },
    subtitle: 'Funder Portal',
    sidebarSubtitle: 'powered by HaliSoft'
  }
};

/**
 * Get branding configuration for a specific tenant type
 * @param {string} tenantType - The tenant type (HALIFLOW, HALIAGENT, etc.)
 * @returns {Object} Branding configuration object
 */
export const getBranding = (tenantType) => {
  const type = (tenantType || 'HALIFLOW').toUpperCase();
  return {
    colors: BRAND_COLORS[type] || BRAND_COLORS.HALIFLOW,
    logo: BRAND_LOGOS[type] || BRAND_LOGOS.HALIFLOW,
    info: BRAND_INFO[type] || BRAND_INFO.HALIFLOW
  };
};

export default {
  BRAND_COLORS,
  BRAND_LOGOS,
  BRAND_INFO,
  getBranding
};
